<template>
	<tbody v-if="hasCurrentRequest && $checkPermissions(['restore_subcontracts'])">
		<tr>
			<td colspan="100%" class="pa-0">
				<div>
					<div class="d-flex align-center mb-1 px-3 py-2 warning" style="gap: 10px;">
						<v-icon >mdi-alert-circle-outline</v-icon>
						<p class="mb-0 font-weight-bold">Solicitud para {{requestText}} subcontrato</p>
					</div>
					<div class="d-flex align-start flex-wrap px-3 py-2" style="gap: 20px;">
						<div style="max-width: 550px;">
							<p class="mb-0" style="font-size: 12px;">El responsable del proyecto ha solicitado {{requestText}} el subcontrato con el contratista.</p>
							<p class="mt-0 mb-2 text--secondary font-weight-bold">Tienes el permiso de la empresa para Aceptar o Rechazar esta solicitud.</p>
							<div>
								<p
									class="mb-0 mt-0"
									style="
										font-size: 12px;
										max-width: 100%;
										overflow-wrap: break-word;
										word-break: break-word;
										min-width: 0;
									"
								><b>Motivo / Observación:</b> {{ currentRequest?.observation || 'Sin motivo especificado' }}</p>
							</div>
						</div>
						<div style="max-width: 520px;">
							<v-textarea
								v-model="observation"
								label="Observación / Comentario (opcional)"
								outlined
								dense
								hide-details
								rows="2"
								color="black"
								style="width: 100%;"
							></v-textarea>
							<div class="d-flex align-center mt-2" style="gap: 10px;">
								<v-btn
									color="green"
									small
									dark
									class="d-flex flex-1"
									@click="acceptRejectSubcontractRestauration(1, subcontract)"
								>
									Aceptar {{requestText}} Subcontrato
								</v-btn>
								<v-btn
									color="#FF120B"
									small
									dark
									class="d-flex flex-1"
									@click="acceptRejectSubcontractRestauration(2, subcontract)"
								>
									Rechazar {{requestText}} Subcontrato
								</v-btn>
							</div>
						</div>
					</div>
				</div>
			</td>
		</tr>
	</tbody>
</template>
<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { resolveContractStatusRequest } from '@/helpers/api/contracts'
export default {
	name: 'SubcontractRequestsResolutionHandler',
	props: {
		subcontract: {
			type: Object,
			required: true
		}
	},
	computed: {
		contract(){
			return this.subcontract?.subcontract?.contract
		},
		requestText(){
			if(this.subcontract.type === 'active' && this.currentSuspensionRequest){
				return 'suspender'
			}
			return 'restaurar'
		},
		hasCurrentRequest(){
			return (this.subcontract.type === 'active' && this.currentSuspensionRequest) || (this.subcontract.type === 'anulated' && this.currentRestorationRequest)
		},
		currentRequest(){
			if(this.subcontract.type === 'active' && this.currentSuspensionRequest) return this.currentSuspensionRequest
			else if(this.subcontract.type === 'anulated' && this.currentRestorationRequest) return this.currentRestorationRequest
			return null
		},
		currentSuspensionRequest(){
			const suspensionRequest = this.contract?.status_requests.length && this.contract.status_requests[0]
			if(suspensionRequest && suspensionRequest.type == 1 && suspensionRequest.status === 0){
				return suspensionRequest
			}
			return null
		},
		currentRestorationRequest(){
			const suspensionRequest = this.contract?.status_requests.length && this.contract.status_requests[0]
			if(suspensionRequest && suspensionRequest.type == 2 && suspensionRequest.status === 0){
				return suspensionRequest
			}
			return null
		},
	},
	data() {
		return {
			observation: null,
		}
	},
	methods: {
		async acceptRejectSubcontractRestauration(new_status, subcontract){
			const data = {
				contract_status_request_id: this.currentRequest.id,
				new_status,
				observation: this.observation,
				project_cost_subcontract_id: subcontract.subcontract_info?.id
			}
			this.observation = null
			const resolve = await resolveContractStatusRequest(data)
			if(resolve.code == 200){
				eventBus.$emit('reloadInformation')
				const messageData = {
					message: 'Se ha resuelto la solicitud, se le ha notificado al usuario responsable.',
					title: 'Solicitud resuelta',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'No se pudo completar la acción, por favor intenta nuevamente.',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	}
}
</script>

<style>

</style>